<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title step__title_smspace">Прикрепите документы</h3>
      <p class="step__subtitle">Документы могут быть в формате pdf, jpg, png, tiff, каждый не больше 10 мб.</p>
      <p class="step__text">Заполненный бланк Заявления (от каждого Выгодоприобретателя, если данное заявление не содержит всей информации)</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(0, $event)" name="files-blank[]" v-model="form.files.blank" />
      <p class="step__text">Паспорт (основной разворот и страница с пропиской)</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(1, $event)" name="files-passport[]" v-model="form.files.passport" />
      <p class="step__text">Выписка из амбулаторной карты / Извещение о больном Ф090/У (для онкозаболеваний) / Выписка из Канцер-регистра (для онкозаболеваний)</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(2, $event)" name="files-vipiska[]" v-model="form.files.vipiska" />
      <h4 v-if="dynamicFields.criminalCase" class="step__title step__title_left">В случае ДТП или в результате получения телесных повреждений (НС):</h4>
      <p v-if="dynamicFields.criminalCase" class="step__text">Постановление о возбуждении/ отказе в возбуждении уголовного дела</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(3, $event)" v-if="dynamicFields.criminalCase" name="files-criminalCase[]" v-model="form.files.criminalCase" />
      <h4 v-if="dynamicFields.death" class="step__title step__title_left">В случае смерти:</h4>
      <p v-if="dynamicFields.death" class="step__text">Справка о смерти/ Медицинское свидетельство о смерти</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(4, $event)" v-if="dynamicFields.death" name="files-deathproof[]" v-model="form.files.deathproof" />
      <p v-if="dynamicFields.death" class="step__text">Свидетельство о праве на наследство по закону или справка о круге наследников</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(5, $event)" v-if="dynamicFields.death" name="files-legacyproof[]" v-model="form.files.legacyproof" />
      <p v-if="dynamicFields.death" class="step__text">Акт судебно-медицинского исследования трупа</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(6, $event)" v-if="dynamicFields.death" name="files-bodyresearchproof[]" v-model="form.files.bodyresearchproof" />
      <h4 v-if="dynamicFields.invalid" class="step__title step__title_left">В случае получения инвалидности:</h4>
      <p v-if="dynamicFields.invalid" class="step__text">Справка об установлении группы инвалидности</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(7, $event)" v-if="dynamicFields.invalid" name="files-invalidproof[]" v-model="form.files.invalidproof" />
      <p v-if="dynamicFields.invalid" class="step__text">Протокол медико-социальной экспертизы</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(8, $event)" v-if="dynamicFields.invalid" name="files-medprotocol[]" v-model="form.files.medprotocol" />
      <h4 class="step__title step__title_left">Дополнительные документы</h4>
      <p class="step__text">Прикрепить дополнительные документы</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(9, $event)" name="files-additinal[]" v-model="form.files.additinal" />
      <Btn class="step__next" :disabled="!filled" @click="CheckExtsAndGoNext">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from '../Btn.vue';
import FileInput from '../inputs/FileInput.vue';
import { mapState } from 'vuex';

export default {
  components: { FileInput, Btn },
  data: () => ({
    fileExts: [[], [], [], [], [], [], [], [], [], []],
    forbiddenFileExts: [],
    refreshKey: 0
  }),
  props: {
    active: { type: Boolean }
  },
  methods: {
    setFileExts(index, array) {
      this.fileExts[index] = array
      this.refreshKey++
    },
    async CheckExtsAndGoNext() {
      try {
        let exts = Array.from(this.fileExts.flat())
        let res = await this.$store.dispatch('sendExts', exts.map(el=>el.toLowerCase()))
        if (res === false) {
          return this.$store.dispatch('showErrorPopup', {
            title: 'Ошибка!',
            text: 'Попробуйте повторить запрос',
            button: 'Повторить',
            action: this.CheckExtsAndGoNext
          })
        }
        let forbidden = []
        for (let i = 0; i < res.length; i++)
          if (res[i])
            forbidden.push(exts[i])
        forbidden = Array.from(new Set(forbidden))
        this.forbiddenFileExts = forbidden
        if (this.forbiddenFileExts.length)
          return
      } catch (err) {
        console.error(err)
        return this.$store.dispatch('showErrorPopup', {
          title: 'Ошибка!',
          text: 'Попробуйте повторить запрос',
          button: 'Повторить',
          action: this.CheckExtsAndGoNext
        })
      }
      this.$store.commit('nextStep')
    }
  },
  computed: {
    ...mapState(['form']),
    dynamicFields() {
      let obj = {
        criminalCase: false,
        death: false,
        invalid: false,
      }
      if (this.form.event.reason == 'Несчастный случай')
        obj.criminalCase = true
      if (this.form.event.type == 'Смерть')
        obj.death = true
      if (this.form.event.type.toLowerCase().match(/^инвалидность/))
        obj.invalid = true
      return obj
    },
    filled() {
      let required = [] //'blank', 'passport', 'vipiska'
      this.refreshKey;
      /*
      if (this.dynamicFields.death) 
        required.push('deathproof')
      if (this.dynamicFields.invalid)
        required.push('invalidproof')
      */
      for (let key of required)
        if (!this.form.files[key] || !this.form.files[key].length) return false
      if (this.forbiddenFileExts.length) {
        let set = new Set(this.fileExts.flat())
        for (let ext of this.forbiddenFileExts)
          if (set.has(ext))
            return false
      }
      return true
    }
  }
}
</script>

<style lang="sass">

</style>